module.exports = __webpack_public_path__ + "static/chicago-d84841b02eb06fea86633aa3cd1de74f.png";